import React from 'react';
import { connect } from 'react-redux';

import { basketSelectors } from '@store/basket/selectors';
import { NormalizedStore } from '@store/entity/entity.types';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { RoomDetailV2 } from './RoomDetailV2';
import {
  RoomDetailV2DispatchProps,
  RoomDetailV2OwnProps,
  RoomDetailV2StoreProps,
} from './RoomDetailV2.types';

const mapStateToProps = (state: NormalizedStore): RoomDetailV2StoreProps => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  roomIdsInBasket:
    basketSelectors.getBasketDetails(state)?.items?.map((room) => room?.bookable?.ids?.roomId) ||
    [],
});

const mapDispatchToProps = (dispatch): RoomDetailV2DispatchProps => ({
  changeJourneyParam: (param, value) => changeJourneyParam(param, value)(dispatch),
});

export const RoomDetailV2Connected: React.ComponentType<RoomDetailV2OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomDetailV2);
